export default (that) => [
  {
    text: that.$l('btn_label_view') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
    showMenu: () => true,
  },
  {
    text: that.$l('btn_label_review') || '信息审核',

    icon: 'el-icon-check',
    menuType: 'review',
    divided: true,
    allow: 'C',
    data: {},
    showMenu: ({ platformStatus }) => platformStatus === 'S',
  },
]
